import { render, staticRenderFns } from "./Step2CycloneInsurance.vue?vue&type=template&id=23486ea5&"
import script from "./Step2CycloneInsurance.vue?vue&type=script&lang=js&"
export * from "./Step2CycloneInsurance.vue?vue&type=script&lang=js&"
import style0 from "./Step2CycloneInsurance.vue?vue&type=style&index=0&id=23486ea5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports